export default __webpack_public_path__ + "static/madbox-f5283286030c18af58b894d9bcd1f8b8.svg";